import {SubscriptionSettings, SubscriptionFrequencyWithLiterals} from '@wix/auto_sdk_ecom_current-cart-v-2';
import {FreeTrialPeriodModel} from './FreeTrialPeriod.model';

export class SubscriptionSettingsModel {
  public frequency: SubscriptionFrequency;
  public interval: number;
  public billingCycles: number;
  public startDate?: Date;
  public freeTrialPeriod: FreeTrialPeriodModel;
  public autoRenewal: boolean;

  constructor(params: SubscriptionSettingsModel) {
    this.frequency = params.frequency;
    this.interval = params.interval;
    this.billingCycles = params.billingCycles;
    this.startDate = params.startDate;
    this.freeTrialPeriod = params.freeTrialPeriod;
    this.autoRenewal = params.autoRenewal;
  }

  public static fromCartV1(subscriptionSettings: SubscriptionSettings) {
    return new SubscriptionSettingsModel({
      frequency: toSubscriptionFrequency(subscriptionSettings?.frequency),
      interval: subscriptionSettings?.interval ?? 0,
      billingCycles: subscriptionSettings?.billingCycles ?? 0,
      startDate: subscriptionSettings?.startDate ?? undefined,
      freeTrialPeriod: FreeTrialPeriodModel.fromCartV1(subscriptionSettings?.freeTrialPeriod),
      autoRenewal: Boolean(subscriptionSettings?.autoRenewal),
    });
  }

  /* istanbul ignore next */
  // eslint-disable-next-line sonarjs/no-identical-functions
  public static fromCartV2(subscriptionSettings: SubscriptionSettings): SubscriptionSettingsModel {
    return new SubscriptionSettingsModel({
      frequency: toSubscriptionFrequency(subscriptionSettings?.frequency),
      interval: subscriptionSettings?.interval ?? 0,
      billingCycles: subscriptionSettings?.billingCycles ?? 0,
      startDate: subscriptionSettings?.startDate ?? undefined,
      freeTrialPeriod: FreeTrialPeriodModel.fromCartV2(subscriptionSettings?.freeTrialPeriod),
      autoRenewal: Boolean(subscriptionSettings?.autoRenewal),
    });
  }
}

export enum SubscriptionFrequency {
  DAY = 'DAY',
  WEEK = 'WEEK',
  MONTH = 'MONTH',
  YEAR = 'YEAR',
  UNDEFINED = 'UNDEFINED',
}

export const toSubscriptionFrequency = (frequency?: SubscriptionFrequencyWithLiterals | null) => {
  switch (frequency) {
    case 'DAY':
      return SubscriptionFrequency.DAY;
    case 'WEEK':
      return SubscriptionFrequency.WEEK;
    case 'MONTH':
      return SubscriptionFrequency.MONTH;
    case 'YEAR':
      return SubscriptionFrequency.YEAR;
    default:
      return SubscriptionFrequency.UNDEFINED;
  }
};
